<template>
  <div class="api-integrations-tab">
    <ApiTabEmptyState
      v-if="!integrations.length"
      title="No integrations yet"
      description="Create an integration to get a client ID and secret, then exchange them for tokens using the OAuth 2.0 flow."
      create-cta-text="Create integration"
      :icon="['fak', 'integration']"
      @create="openCreate('integrations')"
    />
    <template v-else>
      <ApiResourceCard
        v-for="integration in integrationCards"
        :key="integration.id"
        :name="integration.name"
      >
        <template #actions>
          <ApiResourceCardActions
            action-text="Settings"
            :action-icon="['fak', 'settings']"
            :resource-name="integration.name"
            @action="openDetail('integrations', integration.id)"
          />
        </template>
        <ApiMetaList>
          <ApiMetaItem
            v-for="item in integration.metaItems"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
            <ApiCopyValue
              v-if="item.copyLabel"
              :value="item.value"
              :label="item.copyLabel"
            />
          </ApiMetaItem>
        </ApiMetaList>
      </ApiResourceCard>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { computed } from 'vue';

import ApiCopyValue from '../components/ApiCopyValue.vue';
import ApiMetaItem from '../components/ApiMetaItem.vue';
import ApiMetaList from '../components/ApiMetaList.vue';
import ApiResourceCard from '../components/ApiResourceCard.vue';
import ApiResourceCardActions from '../components/ApiResourceCardActions.vue';
import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';
import { API_INTEGRATION_FIXTURES as integrations } from '../fixtures/integrations';
import useApiRoutes from '../useApiRoutes';

useHead({ title: 'API Integrations - Crossbeam' });

const { openCreate, openDetail } = useApiRoutes();

const integrationCards = computed(() =>
  integrations.map((integration) => ({
    id: integration.id,
    name: integration.name,
    metaItems: [
      {
        label: 'Client ID',
        value: integration.clientId,
        copyLabel: `client ID for ${integration.name}`,
      },
      { label: 'Created', value: integration.created },
      { label: 'Last used', value: integration.lastUsed },
      { label: 'Callback URL', value: integration.callbackUrl },
    ],
  })),
);
</script>
